<div class="modal-wrapper">
  <div class="modal-header">
    <h5 ngbAutoFocus tabindex="0" class="modal-title">Update your {{type | lowercase}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>
      Select your {{type | lowercase}}@if (numConc > 1) {
      <span>s</span>
      } here. It's your responsibility to keep this up to date and to make sure you're on track to satisfy all the requirements.
    </p>
    @if (profileService.editConcentrations$ | async; as concData) {
      <div class="row">
        @for (item of concData.concentrations; track item) {
          <div class="col-4">
            <p>{{item.Name}}:</p>
          </div>
          <div class="col-8">
            <select [(ngModel)]="item.Value" class="form-select" id="{{item.Name}}" name="{{item.Name}}">
              @if (item.Name != 'Track') {
                <option value=""></option>
              }
              @for (option of item.Options; track option) {
                @if ((item.Name != 'Secondary') || ((item.Name == 'Secondary') && (concData.concentrations[0].Value != option))) {
                  <option [ngValue]="option">{{option}}</option>
                }
              }
            </select>
          </div>
        }
      </div>
      @if (concData.concentrations.length > 1 && concData.concentrations[0].Value == '' && concData.concentrations[1].Value != '') {
        <div class="row m-2">
          <div class="alert alert-danger">You can't select a Secondary Concentration without a Primary Concentration'</div>
        </div>
      }
      <div class="row">
        @if (concData.history.length > 0) {
          <div class="col-12">
            <a data-bs-toggle="collapse" (click)="isHistoryExpanded = !isHistoryExpanded" href="#history">{{isHistoryExpanded ? 'Hide' : 'Show'}} History</a>
            <div id="history" class="collapse container">
              @for (item of concData.history; track item) {
                <div class="row">
                  <div class="col-4">
                    <small>{{item.Timestamp | date : 'short'}}</small>
                  </div>
                  <div class="col-8">
                    <small>
                      @if (item.Primary != null) {
                        <span>{{item.Primary == '' ? 'None' : item.Primary }}</span>
                      } @else {
                        <span>[unchanged]</span>
                      }
                      @if (item.Secondary != null) {
                        <span>; {{item.Secondary == '' ? 'None' : item.Secondary }}</span>
                      }
                      @if (item.ByAdmin) {
                        <span> (Admin)</span>
                      }
                    </small>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="concData.concentrations.length > 1 && concData.concentrations[0].Value == '' && concData.concentrations[1].Value != ''" (click)="activeModal.close(concData)">Save</button>
      </div>
    } @else {
      <div class="widget-loading text-center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    }


  </div>
</div>
